import { useTranslation } from "react-i18next";
import { ShieldCheck, Server, FlaskConical, FileCheck2 } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, key: "human" },
  { icon: Server, key: "eu" },
  { icon: FlaskConical, key: "science" },
  { icon: FileCheck2, key: "dpo" },
] as const;

export default function RelarkTrustBar() {
  const { t } = useTranslation("ui");
  return (
    <section
      aria-label="Trust bar"
      className="border-y border-border/60 bg-muted/20 py-6"
    >
      <div className="mx-auto max-w-6xl px-5">
        <div className="grid grid-cols-2 gap-x-6 gap-y-4 md:grid-cols-4">
          {ITEMS.map(({ icon: Icon, key }) => (
            <div key={key} className="flex items-start gap-2.5">
              <Icon className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
              <div className="min-w-0">
                <p className="text-xs font-semibold leading-tight text-foreground">
                  {t(`relark.trustBar.${key}`)}
                </p>
                <p className="mt-0.5 text-[11px] leading-snug text-muted-foreground">
                  {t(`relark.trustBar.${key}Sub`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
